import { Dropdown } from './dropdown'

/**
 * Инициализирует все dropdown компоненты на странице
 */
export function initDropdowns(): void {
  const dropdownElements =
    document.querySelectorAll<HTMLElement>('[data-dropdown]')

  dropdownElements.forEach((element) => {
    const name = element.dataset.dropdownName

    // Определяем параметры из DOM структуры
    const multiple = element.classList.contains('dropdown_multiple')
    const buttonLike = element.classList.contains('dropdown_button-appearance')
    const withSearch = !!element.querySelector('[data-dropdown-search]')
    const withDefault = !!element.querySelector('[data-dropdown-default]')

    // Получаем label из триггера
    const triggerContent = element.querySelector(
      '[data-dropdown-trigger-content]'
    )
    const label = triggerContent?.textContent?.trim() || ''

    // Собираем опции из DOM
    const optionButtons = element.querySelectorAll<HTMLElement>(
      '[data-dropdown-option]'
    )
    const options = Array.from(optionButtons).map((button) => ({
      label: button.dataset.dropdownLabel || '',
      value: button.dataset.dropdownValue || ''
    }))

    // Получаем начальное значение из parent элемента (например, data-catalog-sort-value)
    const parentElement = element.parentElement
    let initialValue: string | string[] | undefined
    if (parentElement) {
      // Ищем атрибут вида data-*-value
      const valueAttr = Array.from(parentElement.attributes).find((attr) =>
        attr.name.endsWith('-value')
      )
      if (valueAttr) {
        initialValue = multiple ? valueAttr.value.split(',') : valueAttr.value
      }
    }

    new Dropdown({
      element,
      name,
      label,
      options,
      multiple,
      withSearch,
      withDefault,
      buttonLike,
      value: initialValue
    })
  })
}
